import React from 'react';
export function Hero() {
  return <div className="w-full py-6 md:py-10" data-id="element-390">
      <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-391">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-392">
          30,000 Women Are Using This{' '}
          <span className="text-red-600" data-id="element-393">7-Minute Protocol</span> To Heal From <span className="text-red-600" data-id="element-394">Chronic Anxiety</span>{' '}
        </h1>
        <h2 className="text-2xl md:text-3xl text-gray-700 mb-8 leading-relaxed" data-id="element-395">
          Developed by a trauma therapist with 25+ years of experience, this
          proven protocol helps turn off your body's hidden panic switch & finally feel safe in your body again—especially when meds and therapy fell short.
        </h2>
        <div className="w-full my-6" data-id="element-396">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x3Bnjj4DTzSCCNWPm5jrLr/488007648_973055568144647_6503679057397182315_n_%281%29.jpg" alt="Vagus nerve diagram showing connection to anxiety and sleep issues" className="w-full max-w-2xl mx-auto h-auto object-contain rounded-lg shadow-md" data-id="element-397" />
        </div>
        <div className="flex flex-col md:flex-row items-center gap-6 bg-gray-50 p-6 rounded-lg shadow-sm mb-8" data-id="element-398">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j5zTyzAgttUCqoETGdVR5z/a72d7f-b65f-f3f-db31-1bd8fccf7dda_b5678e5b-b47a-449f-a3a7-7890b1473025_%282%29.webp" alt="Dr. Kim DiRé headshot" className="w-32 h-32 rounded-full object-cover shadow-md" data-id="element-399" />
          <p className="text-gray-700 text-left text-xl font-medium" data-id="element-400">
            <span className="font-semibold" data-id="element-401">Dr. Kim DiRé</span> is a Doctor of
            Behavioral Health and trauma therapist with 20+ years of experience
            helping thousands heal chronic stress, trauma, and nervous system
            dysregulation through somatic therapy.
          </p>
        </div>
        <div className="text-left mt-6" data-id="element-402">
          <p className="text-2xl text-gray-700 mb-5 font-medium" data-id="element-403">
            Dear friend,
          </p>
          <p className="text-xl text-gray-700 mb-5 font-medium" data-id="element-404">
            If you've ever felt your heart flutter… A strange twinge in your
            chest… Or a tightness in your throat that made your stomach drop…
          </p>
          <p className="text-xl text-gray-700 mb-5 font-medium" data-id="element-405">
            And in that moment, your brain whispered: "Something's wrong…"
          </p>
          <p className="text-xl text-gray-700 mb-5 font-medium" data-id="element-406">
            You're not alone.
          </p>
        </div>
      </div>
    </div>;
}